import { apiNoticatoin } from "api"
import { useEffect, useRef, useState } from "react"
import { FormatDate } from "lib/func"
import { messaging } from "lib/firebase"
import { onMessage } from "firebase/messaging"
import { notification } from "components/ui"
import { useRouter } from "next/router"
import useStore from "components/ui/Context"
import classNames from "classnames"

function Notification({ callBackgetCountNoti, setIsShowNoti, typeShow }) {
  const { logOut, toggleModalLogin, userInfo } = useStore()
  const router = useRouter()
  const pageNum = useRef(1)
  const pageTab = useRef()
  // const idTab = useRef()
  const [steps, setSteps] = useState(1)
  const [tabs, setTabs] = useState()
  const [tab, setTab] = useState()
  const __tabActive = useRef(0)
  const [notifications, setNotifications] = useState([])
  const [noti, setNoti] = useState()
  const hasNext = useRef(true)
  const [isCallNoti, setIsCallNoti] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingScroll, setLoadingScroll] = useState(false)
  const [loaddingDetail, setLoadingDetail] = useState(false)
  const containerRef = useRef(null)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 768) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  async function getTabs() {
    try {
      setLoading(true)
      const { data, success } = await apiNoticatoin.getTabs()
      if (success) {
        setTabs(data)
        setTab(data[__tabActive.current])
        if (data?.length > 0) {
          pageTab.current = data[__tabActive.current]?.id
          pageNum.current = 1
          getNottOfTabs()
        }
      }
    } catch (error) {
      console.log(error)
      if (error?.response?.status === 401) {
        logOut()
        setIsShowNoti(false)
        notification.error({
          message: "Phiên đăng nhập hết hạn!"
        })
      }
    } finally {
      // setLoading(false)
    }
  }

  async function getNottOfTabs() {
    setLoading(true)
    if (pageNum.current > 1) {
      setLoadingScroll(true)
    } else {
      setLoadingScroll(false)
    }
    try {
      const { data, success, has_next } = await apiNoticatoin.getNottOfTabs({
        page_num: pageNum.current,
        page_size: 30,
        total: 0,
        id_tab: pageTab.current
      })
      if (pageNum.current === 1) {
        setNotifications(data)
      } else {
        if (success && data?.length > 0) {
          setNotifications((notifications) => [...notifications, ...data])
          // setNotifications([...notifications, ...data])
        }
      }
      hasNext.current = has_next
    } catch (error) {
      console.log(error)
      if (error?.response?.status === 401) {
        logOut()
        setIsShowNoti(false)
        notification.error({
          message: "Phiên đăng nhập hết hạn!"
        })
      }
    } finally {
      setLoading(false)
      setIsCallNoti(false)
      setLoadingScroll(false)
    }
  }

  async function getDetail(id) {
    setLoadingDetail(true)
    let __param = {
      noti_id: id
    }
    try {
      const { success, data } = await apiNoticatoin.getDetailNoti(__param)
      if (success) {
        setNoti(data)
      } else {
        setNoti([])
      }
    } catch (error) {
      setLoadingDetail(false)
      console.log(error)
      if (error?.response?.status === 401) {
        logOut()
        setIsShowNoti(false)
        notification.error({
          message: "Phiên đăng nhập hết hạn!"
        })
      }
    }
  }

  async function MarkRead(key, value) {
    if (key === "all") {
      let __paramMarkread = {
        is_all: true,
        id_tab: tab?.id
      }
      try {
        await apiNoticatoin.markReadNotis(__paramMarkread)
      } catch (error) {
        console.log(error)
        if (error?.response?.status === 401) {
          logOut()
          setIsShowNoti(false)
          notification.error({
            message: "Phiên đăng nhập hết hạn!"
          })
        }
      }
    } else {
      try {
        await apiNoticatoin.markReadNotification(value)
      } catch (error) {
        console.log(error)
        if (error?.response?.status === 401) {
          logOut()
          setIsShowNoti(false)
          notification.error({
            message: "Phiên đăng nhập hết hạn!"
          })
        }
      }
    }
    getTabs()
    callBackgetCountNoti()
  }

  function onChangeTab(value) {
    setNotifications([])
    pageTab.current = value.id
    pageNum.current = 1
    getNottOfTabs()
  }

  const handleHideModal = (e) => {
    if (e.target.id !== "child") {
      setIsShowNoti(false)
    }
  }

  function handleDetail(item) {
    MarkRead("one", item?.noti_id)
    if (item?.type === 5 && item?.data?.deep_link) {
      let url = item?.data?.deep_link
      let video_url = url.split("/video")[1]
      let finnal_url = "/video" + video_url
      if (window) {
        router?.push(window?.location?.origin + finnal_url)
      }
      setIsShowNoti(false)
    } else if (item?.type === 6 && item?.data?.deep_link) {
      let url = item?.data?.deep_link
      let channel_url = url.split("/channel")[1]
      let finnal_url = "/channel" + channel_url
      if (window) {
        router?.push(window?.location?.origin + finnal_url)
      }
    } else {
      setSteps(2)
      getDetail(item?.noti_id)
    }
  }

  useEffect(() => {
    onMessage(messaging, (payload) => {
      if (payload?.messageId) {
        const timer = setTimeout(() => {
          getTabs()
          callBackgetCountNoti()
        }, [2000])

        return () => {
          clearTimeout(timer)
        }
      }
      // ...
    })
  }, [])

  useEffect(() => {
    if (userInfo?.id) getTabs()
  }, [userInfo])

  useEffect(() => {
    function handleScroll() {
      const container = containerRef.current
      if (!container) return
      const { scrollTop, scrollHeight, clientHeight } = container
      const containerHeight = scrollHeight - clientHeight
      const scrolledPercent = scrollTop / containerHeight

      if (scrolledPercent >= 1) {
        setIsCallNoti(true)
      }
    }

    const container = containerRef.current

    container?.addEventListener("scroll", handleScroll)
    return () => {
      container?.removeEventListener("scroll", handleScroll)
    }
  }, [])

  useEffect(() => {
    if (isCallNoti) {
      if (hasNext.current) {
        const timer = setTimeout(() => {
          pageNum.current = pageNum.current + 1
          getNottOfTabs()
        }, 0)
        return () => {
          clearTimeout(timer)
        }
      }
    }
  }, [isCallNoti])

  return (
    <div
      className={classNames("flex flex-col items-center right-16 top-20", {
        fixed: typeShow === "popup"
      })}
      onClick={handleHideModal}
    >
      <div
        className={classNames("flex justify-between rounded-3xl w-[418px] boxNoti", {
          "bg-[#1A1A1A] max-h-[554px] border border-[#FFFFFF33]": typeShow === "popup",
          "w-full": typeShow === "page"
        })}
      >
        {userInfo?.id &&
          (steps === 1 ? (
            <div
              className={`flex flex-col gap-4 items-center w-full ${
                typeShow === "page" ? "pt-0 px-4 pb-5" : "pt-6 px-5 pb-5"
              }`}
              id="child"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex flex-col w-full gap-3">
                <div className="flex justify-between w-full gap-3 py-[3px]">
                  <div className="text-xl leading-7 text-[#FAFAF9] font-semibold">Thông báo</div>
                  <div
                    className={
                      tab?.count > 0
                        ? "text-xs md:text-sm flex items-center cursor-pointer"
                        : "text-xs md:text-sm flex items-center cursor-pointer text-[#D9D9D9] pointer-events-none"
                    }
                    onClick={() => {
                      MarkRead("all")
                    }}
                  >
                    <div
                      className={`${tab?.count > 0 ? "text-primary" : "text-[#5F5F5F]"} ${
                        typeShow === "page" ? "text-base leading-[22px]" : "text-sm leading-[18px]"
                      } font-semibold hover:underline`}
                    >
                      Đọc tất cả
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full flex gap-2 overflow-x-auto min-h-[36px] scrollbar__notification">
                {tabs?.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={
                        __tabActive.current === index
                          ? "flex justify-center items-center cursor-pointer border-[1.2px] border-[#1877F2] rounded-[44px] py-2 px-3 gap-1 text-sm font-normal whitespace-nowrap"
                          : "flex justify-center items-center cursor-pointer border-[1.2px] border-[#5f5f5f] rounded-[44px] py-2 px-3 gap-1 text-sm font-normal whitespace-nowrap"
                      }
                      onClick={() => {
                        if (index !== __tabActive.current) {
                          setTab(item)
                          __tabActive.current = index
                          onChangeTab(item)
                        }
                      }}
                    >
                      {item?.count > 0 && <div className="block">{dotRed}</div>}
                      {item?.name}
                    </div>
                  )
                })}
              </div>
              <div
                className="w-full flex flex-col gap-3 overflow-y-auto overflow-x-hidden scroll__video"
                ref={containerRef}
              >
                {notifications?.length > 0 ? (
                  <>
                    {notifications?.map((item, index) => {
                      return (
                        <div key={index}>
                          {/* <CardText item={item} handleDetail={handleDetail} /> */}
                          {item?.image_uri ? (
                            <CardImg item={item} handleDetail={handleDetail} typeShow={typeShow} />
                          ) : (
                            <CardText item={item} handleDetail={handleDetail} typeShow={typeShow} />
                          )}
                        </div>
                      )
                    })}
                    {loadingScroll && (
                      <div className="flex justify-center items-center">
                        <div className="donut-scroll"></div>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="flex flex-col items-center max-h-[800px] gap-5 max-sm:min-h-[400px] justify-center">
                    {loading && pageNum.current === 1 ? (
                      <div className="flex items-center justify-center">
                        <div className="donut"></div>
                      </div>
                    ) : (
                      <div className="flex flex-col items-center pt-5 pb-[52px]">
                        <img src="/icons/iconNoNotification.svg" alt="" />
                        <div className="flex flex-col gap-2 items-center">
                          <div className="text-[fafaf9] text-xl leading-6 font-semibold">Chưa có thông báo</div>
                          <div className="text-sm leading-[18px] text-[#C6C6C8] font-normal">
                            Chúng tôi sẽ thông báo khi có tin mới
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div
              className={classNames("flex flex-col gap-4 overflow-y-auto overflow-x-hidden", {
                "bg-[#1A1A1A] border border-[#FFFFFF33] px-5 pt-6 pb-5 w-[418px] rounded-[20px] max-h-[554px]":
                  typeShow === "popup",
                "bg-[#131313] px-4 pb-5 w-full": typeShow === "page"
              })}
              id="child"
              ref={containerRef}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex items-center text-xl leading-7 text-[#fafaf9] font-semibold gap-3 max-md:gap-2">
                <span
                  onClick={() => {
                    setSteps(1)
                    setNoti([])
                  }}
                  className="cursor-pointer"
                >
                  <img src="/icons/iconBackLeft.svg" />
                </span>
                Chi tiết thông báo
              </div>
              {noti?._id ? (
                <div className="flex flex-col w-full gap-3">
                  <div className="flex flex-col gap-1.5">
                    <div className="text-base text-[#fafaf9] font-medium">{noti?.title}</div>
                    <div className="text-sm text-[#AFAFAF] font-normal">{FormatDate(noti?.created_at)}</div>
                  </div>
                  {noti?.image_uri ? (
                    <div className="flex w-full justify-center">
                      {noti?.image_uri && (
                        <img
                          className="rounded-[10px] w-full max-w-[378px]"
                          src={
                            noti?.image_uri ||
                            "https://cdn-img.onlivetv.vn/dev/dd753111-bb90-43b4-bb4b-115f784f09c1.png"
                          }
                          width={378}
                          height={214}
                          onError={() => {
                            "https://cdn-img.onlivetv.vn/dev/dd753111-bb90-43b4-bb4b-115f784f09c1.png"
                          }}
                        />
                      )}
                    </div>
                  ) : (
                    <div className="hidden"></div>
                  )}
                  <div className="text-sm text-secondary font-normal text-justify">{noti?.body}</div>
                </div>
              ) : (
                <div className="flex flex-col justify-center items-center h-[400px] rounded-b-lg">
                  {loaddingDetail ? (
                    <div className="flex items-center justify-center">
                      <div className="donut"></div>
                    </div>
                  ) : (
                    <>
                      <img src="/icon/iconMailbox.png" alt="" />
                      <div className="text-primary-dark">Thông báo không tồn tại</div>
                    </>
                  )}
                </div>
              )}
            </div>
          ))}

        {!userInfo?.id && (
          <div
            className={`flex flex-col gap-4 items-center w-full ${
              typeShow === "page" ? "pt-0 px-4 pb-5" : "pt-6 px-5 pb-5"
            }`}
            id="child"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex flex-col w-full gap-3">
              <div className="flex justify-between w-full gap-3 py-[3px]">
                <div className="text-xl leading-6 text-[#FAFAF9] font-semibold">Thông báo</div>
                <div
                  className={
                    tab?.count > 0
                      ? "text-xs md:text-sm flex items-center cursor-pointer"
                      : "text-xs md:text-sm flex items-center cursor-pointer text-[#D9D9D9] pointer-events-none"
                  }
                  onClick={() => {
                    MarkRead("all")
                  }}
                >
                  <div
                    className={`${tab?.count > 0 ? "text-primary" : "text-[#5F5F5F]"} ${
                      typeShow === "page" ? "text-base leading-[22px]" : "text-sm leading-[18px]"
                    } font-semibold hover:underline`}
                  >
                    Đọc tất cả
                  </div>
                </div>
              </div>
            </div>
            <div
              className="w-full flex flex-col items-center gap-3 overflow-y-auto overflow-x-hidden scroll__video max-sm:min-h-[400px] justify-center"
              ref={containerRef}
            >
              {typeShow === "page" && <img src="/icons/iconEarth.svg" width={isMobile ? 120 : 240} />}
              <div className="flex w-full justify-center font-semibold leading-[22px] py-6 max-md:pt-0">
                Hãy
                <span className="text-[#1877F2] underline mx-1 cursor-pointer" onClick={toggleModalLogin}>
                  Đăng nhập
                </span>
                để sử dụng tính năng
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Notification

function CardText({ item, handleDetail, typeShow }) {
  const { body, title, created_at, is_read } = item
  return (
    <div
      className={`flex flex-col relative justify-center p-3 rounded-xl cursor-pointer ${
        is_read
          ? typeShow === "page"
            ? "bg-[#1a1a1a] hover:bg-[#222222]"
            : "bg-[#232323] hover:bg-[#2E2E2E]"
          : "bg-[#2E2E2E] hover:bg-[#5a5959]"
      }`}
      onClick={() => {
        handleDetail(item)
      }}
    >
      <div className="flex flex-col gap-1">
        <div className="max-md:text-sm text-base text-white font-medium line-clamp-1">{title}</div>
        <div className="absolute right-3 top-3">{!is_read && bigDotRed}</div>
        <div className="max-md:text-xs text-sm font-normal text-[#AFAFAF] line-clamp-2">{body}</div>
      </div>
    </div>
  )
}

function CardImg({ item, handleDetail, typeShow }) {
  const { body, title, created_at, is_read, image_uri } = item
  const [srcImage, setSrcImage] = useState("/placeholder_video.svg")

  useEffect(() => {
    setSrcImage(image_uri)
  }, [image_uri])

  return (
    <div
      className={`flex flex-col relative justify-center p-3 rounded-xl cursor-pointer ${
        is_read
          ? typeShow === "page"
            ? "bg-[#1a1a1a] hover:bg-[#222222]"
            : "bg-[#232323] hover:bg-[#2E2E2E]"
          : "bg-[#2E2E2E] hover:bg-[#5a5959]"
      }`}
      onClick={() => {
        handleDetail(item)
      }}
    >
      <div className="flex flex-col w-full gap-3">
        <div className="flex flex-col font-bold text-base cursor-pointer gap-1 w-full">
          <div className="flex justify-between">
            <div className="max-md:text-sm text-base text-white font-medium line-clamp-1">{title}</div>
            <div className="absolute right-3 top-3">{!is_read && bigDotRed}</div>
          </div>
          <div className="max-md:text-xs text-sm font-normal text-[#AFAFAF] line-clamp-2">{body}</div>
        </div>
        <div className="flex w-full">
          <img
            className="cursor-pointer rounded-lg w-full max-w-[350px]"
            src={srcImage || "https://cdn-img.onlivetv.vn/dev/dd753111-bb90-43b4-bb4b-115f784f09c1.png"}
            width={354}
            height={200}
            onError={() => {
              setSrcImage("https://cdn-img.onlivetv.vn/dev/dd753111-bb90-43b4-bb4b-115f784f09c1.png")
            }}
          />
        </div>
      </div>
    </div>
  )
}

const dotRed = (
  <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="2" cy="2" r="2" fill="#D1242A" />
  </svg>
)

const bigDotRed = (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="4" cy="4" r="4" fill="#D1242A" />
  </svg>
)
